const setBannerPopup = (payload) => ({
  type: "SET_BANNER_POPUP",
  payload,
});

const removeBannerPopup = (payload) => ({
  type: "REMOVE_BANNER_POPUP",
  payload,
});

export default {
  setBannerPopup,
  removeBannerPopup,
};
